export const SECTION_REFRESH_STATUS = {
    NONE: 'none',
    DISABLED: 'disabled',
    ENABLED: 'enabled',
    IN_PROGRESS: 'in-progress',
} as const;

export type SectionRefreshStatus = (typeof SECTION_REFRESH_STATUS)[keyof typeof SECTION_REFRESH_STATUS];

export interface SectionRefreshVm {
    status: SectionRefreshStatus;
    tooltip?: string;
}
